module.exports = __webpack_public_path__ + "img/qr-dummy.933f95c5.jpeg";